export const REPOSITORY_URL = process.env.REACT_APP_REPOSITORY_URL;
export const VERIFY_URL = process.env.REACT_APP_VERIFY_URL;
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const BIGQUERY_API_URL = process.env.REACT_APP_BIGQUERY_API_URL;
export const BIGQUERY_DATASET_NAME =
  process.env.REACT_APP_BIGQUERY_DATASET_NAME;
export const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;
export const UMAMI_WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID;
export const DOCS_URL = "https://docs.sourcify.dev";
export const PLAYGROUND_URL = "https://playground.sourcify.dev";

export const GITTER_URL = `https://gitter.im/ethereum/source-verify`;
export const GITHUB_URL = `https://github.com/argotorg/sourcify`;
export const TWITTER_URL = `https://x.com/sourcifyeth`;
